export const firebaseConfig = {
  apiKey: "AIzaSyBNt5XW7vVOK7-AVFtIA-jTX9LxE3S9QSs",
  authDomain: "joydominoes.firebaseapp.com",
  databaseURL: "https://joydominoes-default-rtdb.firebaseio.com",
  projectId: "joydominoes",
  storageBucket: "joydominoes.appspot.com",
  messagingSenderId: "625206870515",
  appId: "1:625206870515:web:372103b2c9fc38a0ca5286",
  measurementId: "G-CQW9QZ18RV"
}
